import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateNodesFromDOM } from "@lexical/html";
import { $getRoot, $insertNodes, $createParagraphNode } from "lexical";
import { useEffect, useRef } from "react";
import { preprocessDOM } from "../hook/usePreprocessDOM";

/**
 * Initializes the editor with HTML content and ensures LTR direction.
 * This runs only once when the component mounts.
 */
export default function InitialStatePlugin({
  initialHTML,
}: {
  initialHTML?: string;
}): null {
  const [editor] = useLexicalComposerContext();
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current) return;

    editor.update(() => {
      const root = $getRoot();

      // Force LTR on root
      root.setDirection("ltr");
      root.clear();

      if (initialHTML) {
        const parser = new DOMParser();
        // Parse raw HTML
        const rawDom = parser.parseFromString(initialHTML, "text/html");
        // Pre-process: map Lexical class names → semantic tags + clean styles
        const processedDom = preprocessDOM(rawDom);
        //Generating nodes — Lexical can map <strong>, <em>, color styles etc.
        const nodes = $generateNodesFromDOM(editor, processedDom);
        $insertNodes(nodes);
      } else {
        // Ensure at least one paragraph exists
        if (root.isEmpty()) {
          const paragraph = $createParagraphNode();
          paragraph.setDirection("ltr");
          root.append(paragraph);
        }
      }

      isInitialized.current = true;
    });
  }, [editor, initialHTML]);

  return null;
}
